import { __spreadArray } from "tslib";
import { find, includes, map } from 'lodash';
import { createSelector } from 'reselect';
import { ROUTE_PREFIX_CATEGORIES } from '../../constants/route-prefix';
import { getMixedIds, getMixedIdsMap } from '../../services';
import { getInternalLinkRoute } from '../../services/get-internal-link-route';
export var getCategories = function (state) { var _a; return (_a = state.categories) !== null && _a !== void 0 ? _a : []; };
export var getCategoriesSlice = createSelector([getCategories, function (_, size) { return size; }], function (categories, size) { return categories.slice(0, size); });
export var getCategoryIds = createSelector([getCategories], function (categories) {
    return getMixedIds(categories);
});
export var getCategoriesMap = createSelector([getCategories], function (categories) {
    return getMixedIdsMap(categories);
});
export var getCategoryCount = function (state) { return getCategories(state).length; };
export var getCategory = function (state, id) {
    return getCategoriesMap(state)[id];
};
export var getMainCategory = function (state, post) {
    var _a;
    if (post === void 0) { post = {}; }
    return (_a = post.mainCategory) !== null && _a !== void 0 ? _a : resolveMainCategory(state, post);
};
export var getMainCategoryDisplayLabel = getMainCategoryField('label', 'menuLabel');
export var getMainCategorySeoLabel = getMainCategoryField('title', 'label');
export var getMainCategoryLink = function (state, post, topology) {
    if (post === void 0) { post = {}; }
    if (topology === void 0) { topology = {}; }
    if (post.mainCategory) {
        return post.mainCategory.link;
    }
    var mainCategory = resolveMainCategory(state, post);
    if (mainCategory) {
        return getInternalLinkRoute({
            topology: topology,
            to: "/".concat(ROUTE_PREFIX_CATEGORIES, "/").concat(mainCategory.slug),
            shouldNavigateToFeed: true,
        });
    }
};
export var getCategoryBySlug = createSelector([getCategories, function (_, slug) { return slug; }], function (categories, categorySlug) {
    return find(categories, function (category) {
        return includes(category.slugs, categorySlug) ||
            includes(category.slugs, "".concat(categorySlug, "/"));
    });
});
export var getHighestRank = createSelector([getCategories], function (categories) {
    return Math.max.apply(Math, __spreadArray([-1], map(categories, function (category) { var _a; return (_a = category.rank) !== null && _a !== void 0 ? _a : -1; }), false));
});
export var getCategoryByTranslationSlug = createSelector([
    getCategories,
    function (_, slug) { return slug; },
    function (_, __, language) { return language; },
], function (categories, translationSlug, language) {
    return categories.find(function (category) {
        var _a;
        return category.language === language &&
            ((_a = category.translations) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
                var _b;
                var url = _a.url;
                return (_b = url === null || url === void 0 ? void 0 : url.path) === null || _b === void 0 ? void 0 : _b.includes(translationSlug);
            }));
    });
});
function resolveMainCategory(state, post) {
    var _a;
    if (post === void 0) { post = {}; }
    var mainCategoryId = (_a = post.categoryIds) === null || _a === void 0 ? void 0 : _a[0];
    if (mainCategoryId) {
        return getCategory(state, mainCategoryId);
    }
}
function getMainCategoryField(mainCategoryField, fallbackCategoryField) {
    return function (state, post) {
        if (post === void 0) { post = {}; }
        if (post.mainCategory) {
            return post.mainCategory[mainCategoryField];
        }
        var mainCategory = resolveMainCategory(state, post);
        if (mainCategory) {
            return mainCategory[fallbackCategoryField];
        }
    };
}
